<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> تحلیل تخلیه ها </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <form class="row gx-2 gy-3" [formGroup]="mdl_Search">

        <!-- تانکر -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> تانکر </label>

            <select class="form-select" formControlName="strUnitID">

                <option class="text-center" value=""> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of list_Tanker" [value]="item.strUnitID">

                    {{item.strFullName}}

                </option>

            </select>

        </div>

        <!-- از تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> از تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> تا تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- شعاع تخلیه  -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> <small> شعاع تخلیه(متر) </small> </label>

            <input type="text" class="form-control p-2 text-center" formControlName="iRadiusMeters">

        </div>

        <!-- حداکثر تخلیه مجاز  -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> <small> حداکثر تخلیه مجاز(لیتر) </small> </label>

            <input type="text" class="form-control p-2 text-center" formControlName="iMaxAllowableDischarge">

        </div>

        <!-- دکمه ها  -->

        <div class="col-12 col-md-auto position-relative">

            <button class="w-100 btn btn-primary px-md-4" (click)="get_Analysis()"> تحلیل </button>

        </div>

    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-0 gy-2 gy-md-0">

            <div class="col-md-8 col-12"></div>

            <!-- نقشه حبابی -->

            <div class="col-12 col-md-2 position-relative border border-2 b-transparent px-2">

                <button class="btn btn-secondary w-100" (click)="openBubbleMap()">

                    نقشه حبابی

                </button>

            </div>

            <!-- خروجی اکسل -->

            <div class="col-12 col-md-2 position-relative border border-2 b-transparent px-2">

                <button class="btn btn-success w-100" (click)="exportExcel()">

                    خروجی اکسل

                </button>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 270px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th class="text-center col-1"> # </th>

                        <th class="text-center col-1"> عملیات </th>

                        <th class="text-center"> تعداد تخلیه </th>

                        <th class="text-center"> جمع تخلیه(لیتر) </th>

                    </tr>

                </thead>

                <tbody>

                    <ng-container *ngFor="let item of lst_Result;let i = index">

                        <tr class="col-12 text-center"
                            [ngClass]="item.TotalDischarge > mdl_Search.get('iMaxAllowableDischarge')?.value ? 'bg-th-orange' : ''">

                            <th> {{ i + 1 | faNum }} </th>

                            <th class="">

                                <i class="fa fa-info-circle mx-2 fs-5 pointer" title="جزئیات "
                                    (click)="openInfo(item)"></i>

                                <i class="fa fa-map-marker mx-2 fs-5 pointer" title="موقعیت "
                                    (click)="showOnMap(item)"></i>

                            </th>

                            <td> {{ item.MergeCount | faNum }} </td>

                            <td> {{ item.TotalDischarge | number | faNum }} </td>

                        </tr>

                    </ng-container>

                </tbody>

            </table>

        </div>

        <!-- سرجمع -->

        <div class="section mt-2 bg-secondary">

            <p class="my-1 text-white">

                <span class="mx-2"> سرجمع تعداد تخلیه : {{ obj_Report.MergeCount | faNum }} </span>

                <span class="mx-2"> سرجمع تخلیه : {{ obj_Report.TotalDischarge | number | faNum }} لیتر </span>

            </p>

        </div>

    </div>

</main>

<div class="modal fade" id="view_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> جزئیات بیشتر </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="">

                    <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm
                        (keyup)="filter_Analyze($event.target)">

                    <div class="section border border-2 mt-2">

                        <table class="table table-striped bg-white mt-1 dirI" id="excel-list">

                            <thead>

                                <tr class="text-center">

                                    <th scope="col"> # </th>

                                    <th scope="col"> راننده </th>

                                    <th scope="col"> تاریخ </th>

                                    <th scope="col"> ساعت شروع </th>

                                    <th scope="col"> ساعت پایان </th>

                                    <th scope="col"> مقدار تخلیه(لیتر) </th>

                                    <th scope="col"> سرعت </th>

                                    <th scope="col"> آدرس </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr class="f14 text-center" *ngFor="let item of lst_Analyze;let i=index">

                                    <th class="text-dark"> {{ i + 1 | faNum}} </th>

                                    <th class="text-dark"> {{ item.strFullName | faNum}} </th>

                                    <th class="text-dark"> {{ item.strDate | faNum}} </th>

                                    <th class="text-dark"> {{ item.strSTime | faNum}} </th>

                                    <th class="text-dark"> {{ item.strETime | faNum}} </th>

                                    <th class="text-dark"> {{ item.fDischargeValue | number | faNum}} </th>

                                    <th class="text-dark"> {{ item.iSpeed | faNum}} </th>

                                    <th class="text-dark"> {{ item.strAddress | faNum}} </th>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<custom-map *ngIf="bMap" 

    [strValue]="''"

    [longLat]="[mdl_Search.get('fLon')?.value,mdl_Search.get('fLat')?.value]"
    
    [isOpenModal]="true"

    [isView]="true" 
    
    [skip_Search]="true" 
    
    (mdl_Submit)="bMap=false">

</custom-map>